import React, { cloneElement, isValidElement } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

interface NestedRoutesProps {
  children: React.ReactNode;
}

export function NestedRoutes({ children }: NestedRoutesProps) {
  const { path } = useRouteMatch();

  return (
    <Switch>
      {React.Children.map(children, (child) => {
        if (!isRouteComponent(child)) {
          return child;
        }

        if (typeof child.props.path !== 'string') {
          return cloneElement(child, {
            path: [path, ...child.props.path],
          });
        }

        return cloneElement(child, {
          path: path + child.props.path,
        });
      })}
    </Switch>
  );
}

interface RouteElement extends JSX.Element {
  props: {
    children: JSX.Element;
    path: string | string[];
  };
}

function isRouteComponent(element: React.ReactNode): element is RouteElement {
  return isValidElement(element) && element.type === Route;
}
